import styled from 'styled-components';

export const ForgetPasswordModal = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.x6} ${theme.spacing.x4}`};
`;

export const ForgetPasswordTextBold = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x6};
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: bold;
`;
export const ForgetPasswordModalText = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const Divider = styled.div`
  margin: ${({ theme }) => ` ${theme.spacing.x3} 0`};
  border: 1px solid #d8dbdf;
`;

export const Text = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: ${({ theme }) => theme.spacing.x2};
`;
// TODO //
export const Button = styled.div`
  width: 134px;

  /* &.none-bg {
                .button(#fff, @blue);
            } */
`;

export const ButtonWrapper = styled.div`
  margin-inline-start: unset !important;
  div {
    gap: ${({ theme }) => theme.spacing.x2};
  }
`;

export const ForgetPasswordModalContainer = styled.div`
  width: 566px;
  max-width: 95%;
`;
